(function ($) {
  var transitionDuration = 200;

  function closeSearch($search) {
    clearTimeout($search.data('avanquestSearchCloseTimer'));
    $search.removeClass('avanquest-search--open');
    $search.find('.avanquest-search__trigger').attr('aria-expanded', 'false');

    $search.data('avanquestSearchCloseTimer', setTimeout(function () {
      $search.find('.avanquest-search__panel').prop('hidden', true);
    }, transitionDuration));
  }

  function openSearch($search) {
    clearTimeout($search.data('avanquestSearchCloseTimer'));
    $search.find('.avanquest-search__trigger').attr('aria-expanded', 'true');
    $search.find('.avanquest-search__panel').prop('hidden', false);

    window.requestAnimationFrame(function () {
      $search.addClass('avanquest-search--open');
      $search.find('.avanquest-search__input').trigger('focus');
    });
  }

  function initSearch($scope) {
    $scope.find('.avanquest-search').each(function () {
      var $search = $(this);

      if ($search.data('avanquestSearchInitialized')) {
        return;
      }

      $search.data('avanquestSearchInitialized', true);

      $search.on('click', '.avanquest-search__trigger', function () {
        if ($search.hasClass('avanquest-search--open')) {
          closeSearch($search);
          return;
        }

        $('.avanquest-search--open').not($search).each(function () {
          closeSearch($(this));
        });
        openSearch($search);
      });
    });
  }

  $(document).on('click', function (event) {
    $('.avanquest-search--open').each(function () {
      var $search = $(this);

      if (!$(event.target).closest('.avanquest-search').length) {
        closeSearch($search);
      }
    });
  });

  $(document).on('keydown', function (event) {
    if (event.key !== 'Escape') {
      return;
    }

    $('.avanquest-search--open').each(function () {
      var $search = $(this);
      closeSearch($search);
      $search.find('.avanquest-search__trigger').trigger('focus');
    });
  });

  $(function () {
    initSearch($(document));
  });

  $(window).on('elementor/frontend/init', function () {
    if (!window.elementorFrontend || !window.elementorFrontend.hooks) {
      return;
    }

    window.elementorFrontend.hooks.addAction(
      'frontend/element_ready/avanquest-search-form.default',
      initSearch
    );
  });
})(jQuery);
